import React, { useState, useEffect } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import {
    formateDateAndTime,
    httpRequestDownload,
    httpRequestGet,
    toaster
} from "../../../utils/utils";
import { useDispatch } from "react-redux";
import apiConstants from "../../../constans/apiConstants";
import DataTable from "../../Table";
import ItemSelect from "../../SelectItemsPerPage/SelectItemsPerPage";
import "react-datetime-range-picker/dist/style.css";
import DatetimeRangePicker from "react-datetime-range-picker";
import ExportExcelButton from "../../Table/ExportExcelButton";

const PolicyReport = () => {
    const [source, setSource] = useState("All");
    const [date, setDate] = useState({
        start: " ",
        end: " ",
    });

    let [startDate, setStartDate] = useState(null);
    let [endDate, setEndDate] = useState(null);
    const [maxEndDate, setMaxEndDate] = useState(null);
    let maxStartDate = new Date();
    const [completeDateFlag, setCompleteDateFlag] = useState(false)

    const [data, setData] = useState([]);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const dispatch = useDispatch();

    const searchData = () => {
        let start = new Date(startDate);
        let end = new Date(endDate);
        if(isNaN(start.getTime())  || isNaN(end.getTime()) ){
            toaster('error', "Invalid date. Use the format DD-MM-YYYY HH:MM:SS")
        }
        else{
           
            let param = `${"fromDate=" + formateDateAndTime(start) + "&pageNum=" + currentPage +"&pageSize=" + recordsPerPage + "&reportType=" + source +  "&sortBy=" +"createdOn" +"&toDate=" +formateDateAndTime(end)}`;
            const path = `${apiConstants().DASHBOARD_API_URL}api/v1/tracker/fetchReportForDashboard?${param}`;
            dispatch({ type: "LOADER_TRUE" });
            httpRequestGet(path)
                .then((res) => {
                    dispatch({ type: "LOADER_FALSE" });
                    if (res && res.data) {
                        setData(res.data.body);
                        toaster("success", res.data.message);
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADER_FALSE" });
                    if (err && err.data) {
                        toaster("error", err.data.message);
                    }
                });
        }
    };

    useEffect(() => {
        if (startDate!= null && endDate!= null) {
            searchData();
        }
    }, [currentPage, recordsPerPage]);

    useEffect(() => {
        if(startDate) {
            startDate = new Date(startDate);
            let md = new Date(startDate.setDate(startDate.getDate() + 30));
            startDate.setDate(startDate.getDate()-30);
            setMaxEndDate({
                maxEndDate: md
            })
        }
    }, [startDate]);

    useEffect(() => {
        if(startDate && endDate) {
            setCompleteDateFlag(true);
            endDate = new Date(endDate);
        }
    }, [endDate]);


    const handleChange = (value) => {
        setSource(value.toString());
    };

    const selectPage = (pgNo) => {
        setCurrentPage(pgNo-1);
    };

    const setMaxRecords = (size) => {
        setRecordsPerPage(size);
    };

    const downloadReport = () => {
        let start = new Date(startDate);
        let end = new Date(endDate);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            toaster('error', "Invalid date. Please use the format DD-MM-YYYY HH:MM:SS");
            return;
        }
    
        if ((end - start) > 2592000000) { // 30 days in milliseconds
            toaster("error", "Start date and end date can't be more than 30 days apart");
            return;
        }
        start = new Date(startDate);
        end = new Date(endDate);
        let param = `${"fromDate=" + formateDateAndTime(start)  +"&toDate=" + formateDateAndTime(end) + "&reportType=" + source}`;
        const path = `${apiConstants().DASHBOARD_API_URL}api/v1/tracker/downloadReport?${param}`;
        dispatch({ type: "LOADER_TRUE" });
        httpRequestDownload(path)
            .then((res) => {
                dispatch({ type: "LOADER_FALSE" });
                if (res && res.data) {
                    var blob = new Blob([res.data], {type: "text/csv"});
                    var objectUrl = URL.createObjectURL(blob);
                    window.open(objectUrl);
                }
            })
            .catch((err) => {
                dispatch({ type: "LOADER_FALSE" });
                if (err && err.data) {
                    toaster("error", err.data.message);
                }
            });
    };

    const header = [
        "Proposal Number",
        "Policy Number",
        "Proposer Name",
        "Proposer DOB",
        "Payment Option",
        "Plan Type",
        "Payment Status",
        "Payment Transaction Date",
        "Partner Name",
        "NBP",
        "Sum Assured",
        "Frequency",
        "Quote No",
        "Email",
        "Phone Number",
        "Policy Status",
        "Journey Status",
        "Created On",
        "Agent Code",
        "Channel",
        "Sub Channel",
        "Product Name",
        "Total Premium",
        "Payment Method",
        "Renewal Method Selected",
        "Bharti Axa Emp Code",
        "Transaction Id",
        "Ref No",
        "Premium_Payment_Term",
        "Policy_Term",
        "LA Name",
        "LA DOB",
        "Nominee Fullname",
        "Nominee Date Of Birth",
        "Nominee Relationship",
        "Pan No",
        "Penny Status",
        "Rider Name",
        "Rider Sum Assured",
        "Document Upload",
        "Issuance Type",
    ];

    const key = [
        "proposalNumber",   
        "policyNumber",
        "proposerName",
        "proposerDateOfBirth",
        "paymentOptionType",
        "planType",
        "paymentStatus",
        "transactionDate",
        "partnerName",
        "premium",
        "sumAssured",
        "premiumPaymentMode",
        "quoteNumber",
        "emailId",
        "mobileNumber",
        "policyStatus",
        "journeyStatus",
        "createdOn",
        "agentCode",
        "channel",
        "subChannel",
        "productName",
        "totalPremium",
        "paymentMethod",
        "renewalPaymentMethod",
        "bhartiAxaEmpCode",
        "transactionId",
        "refNo",
        "premiumPaymentTerm",
        "policyTerm",
        "laName",
        "ladateOfBirth",
        "fullNomineeName",
        "nomineeDateOfBirth",
        "nomineeRelationShip",
        "panNumber",
        "pennyStatus",
        "riderName",
        "riderSumAssured",
        "uploadedDocument",
        "issuanceType"
    ];

    return (
        <div className="policy-report">
            <div className="policy-report__panel">
                <div className="policy-report__grid">
                    <div className="policy-report__field policy-report__field--source">
                        <label className="policy-report__label" htmlFor="policy-source">
                            Source
                        </label>
                        <select
                            id="policy-source"
                            name="source"
                            className="policy-report__select"
                            value={source}
                            onChange={(e) => handleChange(e.target.value)}
                        >
                            <option value="All">All</option>
                            <option value="MSell">MSell</option>
                            <option value="D2C">D2C</option>
                        </select>
                    </div>

                    <div className="policy-report__field">
                        <label className="policy-report__label" htmlFor="policy-start-date">
                            Start Date
                        </label>
                        <Datetime
                            inputProps={{
                                id: "policy-start-date",
                                placeholder: "DD-MM-YYYY HH:mm:ss",
                            }}
                            value={startDate}
                            onChange={(date) => setStartDate(date)}
                            isValidDate={(current) => current.isBefore(maxStartDate)}
                            dateFormat="DD-MM-YYYY"
                            timeFormat="HH:mm:ss"
                        />
                    </div>

                    <div className="policy-report__field">
                        <label className="policy-report__label" htmlFor="policy-end-date">
                            End Date
                        </label>
                        <Datetime
                            inputProps={{
                                id: "policy-end-date",
                                placeholder: "DD-MM-YYYY HH:mm:ss",
                            }}
                            disabled={!startDate}
                            value={endDate}
                            onChange={(date) => setEndDate(date)}
                            isValidDate={(current) =>
                                current.isBefore(maxEndDate?.maxEndDate)
                            }
                            dateFormat="DD-MM-YYYY"
                            timeFormat="HH:mm:ss"
                        />
                    </div>
                </div>

                {completeDateFlag && (
                    <div className="policy-report__actions">
                        <button
                            type="button"
                            className="policy-report__btn policy-report__btn--primary"
                            onClick={searchData}
                        >
                            Apply
                        </button>
                    </div>
                )}
            </div>

            {data.itemList && data.itemList.length > 0 && (
                <>
                    <div className="policy-report__toolbar inline-page-report">
                        <ItemSelect
                            itemsPerPage={recordsPerPage}
                            setItemsPerPage={setMaxRecords}
                        />
                        <ExportExcelButton onClick={downloadReport} />
                    </div>
                    <div className="proposal-dashboard__table-section policy-report__table-section">
                        <DataTable
                            cellHeaders={header}
                            data={data.itemList}
                            keys={key}
                            addSerialNo={true}
                            fileName="Policy report"
                            showExcelDownload={false}
                            PerPageApiData={true}
                            itemsPerPage={recordsPerPage}
                            currentPage={currentPage}
                            setCurrentPage={selectPage}
                            alwaysShown={false}
                            paginationItems={data}
                            convertValueToString={true}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default PolicyReport;
